module.exports = __webpack_public_path__ + "assets/img/cp.117c88f6.png";